import {Range, getTrackBackground} from 'react-range';


export default function Slider ({ values, setValues, MIN=0, MAX=100, STEP=0.1, fmt=(v) => v.toFixed(1) }){
  /*
  options:
  https://www.npmjs.com/package/react-range
  https://github.com/zlatanpham/histogram-slider
  https://github.com/samhogg/histoslider
  https://github.com/react-component/slider
  https://github.com/johnwalley/d3-simple-slider
  d3 own
    https://observablehq.com/@d3/brush-snapping?collection=@d3/d3-brush
    https://observablehq.com/@d3/histogram
  */

  // const STEP = 0.1;
  // const MIN = 0;
  // const MAX = 100;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}
    >
      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={MAX}
        // rtl={rtl}
        onChange={(values) => setValues(values)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: '36px',
              display: 'flex',
              width: '100%'
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '5px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values,
                  colors: ['#ccc', '#548BF4', '#ccc'],
                  min: MIN,
                  max: MAX,
                  // rtl
                }),
                alignSelf: 'center'
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ index, props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: '20px',
              width: '20px',
              borderRadius: '2px',
              backgroundColor: '#FFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0px 2px 6px #AAA'
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '-20px',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '10px',
                fontFamily: 'Arial,Helvetica Neue,Helvetica,sans-serif',
                padding: '2px',
                borderRadius: '2px',
                backgroundColor: '#548BF4'
              }}
            >
              {fmt(values[index])}
            </div>
            <div
              style={{
                height: '16px',
                width: '5px',
                backgroundColor: isDragged ? '#548BF4' : '#CCC'
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
